import { render } from "./navigation.vue?vue&type=template&id=d846a282&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"

import "./navigation.vue?vue&type=style&index=0&id=d846a282&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d846a282"]])

export default __exports__